// 教育经历
import {
  AutoComplete, Form, Icon, Selector, Input,
} from '@roo/roo';
import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { requiredRule } from '../../../../utils/rules';
import { FieldList } from '../../_components/FieldList';
import { queryMajor, querySchool } from '../../../../assets/apis/scientist';
import { getPopContainer } from '../../_utils';

dayjs.locale('zh-cn');
const Field = Form.field;

const schoolList = [
  { value: 1, label: '学士' },
  { value: 2, label: '硕士' },
  { value: 3, label: '博士' },
];

const eduInfoObj = {
  startTime: '', // 开始时间
  endTime: '', // 结束时间
  collegeName: '', // 学校名称
  major: '', // 专业
  degreeType: '', // 学位
  mentor: '', // 导师
};

const Education = (props) => (
  <FieldList {...props} name="eduInfo" hid maxCount={5} minCount={1} iniData={eduInfoObj} plusText="添加教育经历" itemClassName="form-patch bc" itemStyle={{ marginTop: 32 }}>
    <Field
      required
      name="startTime"
      rule={{
        validator: (rule, value, callback) => {
          if (!value) {
            return callback('请选择日期');
          }
          return callback();
        },
      }}
      label="时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间"
    >
      {({
        disabled, idx, item, setFieldValue, handleChange, ...rest
      }) => {
        const { startTime, endTime: endtime } = item;
        const endTime = endtime === '至今' ? dayjs().format('YYYY-MM-DD') : endtime;
        return (
          <DatePicker.RangePicker
            className="as-roo-rangepicker"
            allowClear={false}
            disabled={disabled}
            disabledDate={(cur) => cur.unix() > Date.now() / 1000}
            value={startTime && endTime ? [dayjs(startTime), dayjs(endTime)] : undefined}
            onChange={(v) => {
              const [start, end] = v;
              handleChange(startTime);
              setFieldValue(`eduInfo.${idx}`, {
                ...item,
                startTime: dayjs(start).format('YYYY-MM-DD'),
                endTime: dayjs(end).format('YYYY-MM-DD'),
              });
            }}
            format={(value) => {
              if (dayjs().format('YYYY-MM-DD') === endTime && endTime === value.format('YYYY-MM-DD') && startTime !== value.format('YYYY-MM-DD')) {
                return '至今';
              }
              return value.format('YYYY-MM-DD');
            }}
            cellRender={(current, info) => {
              if (current.format('YYYY-MM-DD') === info.today.format('YYYY-MM-DD')) {
                return <div className="ant-picker-cell-inner">至今</div>;
              }
              return info.originNode;
            }}
          />
        );
      }}
    </Field>
    <Field
      required
      hid
      rule={requiredRule}
      label="学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;校"
      name="collegeName"
      as={(
        <AutoComplete
          filterable
          disablePortal
          popupContainer={getPopContainer}
          fetchSuggestions={(queryString, callback) => {
            querySchool({ keyWord: queryString })
              .then((res) => {
                callback(res);
              })
              .catch(() => {
                callback([]);
              });
          }}
        />
      )}
    />
    <p className="info">
      <Icon name="info-circle-o" />
      若查询不到，可手动填写
    </p>
    <Field
      required
      hid
      label="专&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业"
      rule={requiredRule}
      name="major"
      as={(
        <AutoComplete
          filterable
          disablePortal
          popupContainer={getPopContainer}
          fetchSuggestions={(queryString, callback) => {
            queryMajor({ keyWord: queryString })
              .then((res) => {
                callback(res);
              })
              .catch(() => {
                callback([]);
              });
          }}
        />
      )}
    />
    <p className="info">
      <Icon name="info-circle-o" />
      若查询不到，可手动填写
    </p>
    <Field
      required
      hid
      label="学位类型"
      name="degreeType"
      rule={{ ...requiredRule, required: true, type: 'number' }}
      as={<Selector options={schoolList} filterable disablePortal />}
    />
    <Field
      required
      hid
      rule={requiredRule}
      label="导&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;师"
      name="mentor"
      as={<Input maxLength={50} placeholder="请输入您此段教育经历的关键导师" />}
    />
  </FieldList>
);

export default Education;
